import { Controller } from "@hotwired/stimulus";

// Toggles the mobile nav hamburger and individual accordion sub-sections.
export default class extends Controller {
  static targets = ["menu"];

  toggle() {
    this.menuTarget.classList.toggle("hidden");
  }

  toggleAccordion(event) {
    const subList = event.currentTarget.nextElementSibling;
    if (!subList) return;

    subList.classList.toggle("hidden");
    const expanded = !subList.classList.contains("hidden");
    event.currentTarget.setAttribute("aria-expanded", expanded.toString());
  }

  closeOnClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.menuTarget.classList.add("hidden");
    }
  }

  closeOnEscape(event) {
    if (event.key === "Escape") this.menuTarget.classList.add("hidden");
  }
}
